import { TenantService }            from "@/services/TenantService"
import { CatalogService }             from "@/services/CatalogService"
import { constants }                from "@/const.js"

const state = {
  tenantDetails: {},
  catalogRoot: undefined,
  catalogIsLoading: false,
  categoryHistory: [],
  currentCategoryId: 0,
  categoryIsLoading: false
}

const getters = {
  tenantDetails: state => state.tenantDetails,
  IsMcfa: state => {
    return state.tenantDetails.McfCostCenter === constants.MCFA
  },
  IsMcfe: state => {
    return state.tenantDetails.McfCostCenter === constants.MCFE
  },
  IsMcfs: state => {
    return state.tenantDetails.McfCostCenter === constants.MCFS
  },
  McfCostCenterId: state => {
    if(state.tenantDetails.McfCostCenter === constants.MCFA){
      return 1
    }
    if(state.tenantDetails.McfCostCenter === constants.MCFE){
      return 2
    }
    if(state.tenantDetails.McfCostCenter === constants.MCFS){
      return 3
    }
    return 1;
  },
  SiteName: state => {
    var hostName = location.hostname;
    if(hostName.includes("mcfa")){
      return "MCFA"
    }
    if(hostName.includes("eudealernet") || location.port == "8081"){
      return "MCFE"
    }
    if(hostName.includes("apdealernet") || location.port == "8082"){
      return "MCFS"
    }
    if(hostName.includes("uca")){
      return "UCA"
    }

    return "MCFA";
  },
  IsSectionEnabled: state => sectionName => {
    if (state.tenantDetails.Sections === undefined)
    {
      return false;
    }
    let section = state.tenantDetails.Sections.find((section) => {
      return section.SectionName == sectionName
    })
    return section !== undefined
  },
  IsSectionEnabledAllUppercase: state => sectionName => {
    if (state.tenantDetails.Sections === undefined)
    {
      return false;
    }
    let section = state.tenantDetails.Sections.find((section) => {
      return section.SectionName.toUpperCase().trim() == sectionName.toUpperCase().trim();
    })
    return section !== undefined
  },
  CatalogRoot: state => {
    return state.catalogRoot
  },
  CatalogRootByCategoryId: state => categoryId => {
    return state.catalogRoot.find( rootCategory =>{
      return rootCategory.Id === categoryId
    })
  },
  CatalogIsLoading: state => {
    return state.catalogIsLoading
  },
  CurrentCategory: state => {
    let category = state.categoryHistory.find(category => {
      return category.Id == state.currentCategoryId
    })

    return category
  },
  CategoryIsLoading: state => {
    return state.categoryIsLoading
  }
}

const mutations = {
  SET_TENANT_DETAILS: function (state, tenantDetails) {
    state.tenantDetails = tenantDetails
  },
  SET_CATALOG_ROOT: function(state, catalogRoot) {
    state.catalogRoot = catalogRoot
  },
  SET_CATALOG_IS_LOADING: function(state, isLoading) {
    state.catalogIsLoading = isLoading
  },
  SET_CATEGORY_HISTORY: function(state, category) {
    state.categoryHistory.push(category)
  },
  SET_CURRENT_CATEGORY_ID: function(state, categoryId){
    state.currentCategoryId = categoryId;
  },
  SET_CATEGORY_IS_LOADING: function(state, isLoading){
    state.categoryIsLoading = isLoading
  },
  SET_CATEGORY_ROOT_CHILDREN: function(state, payload){
    var matchingRootCategory = state.catalogRoot.find(category => {
      return category.Id === payload.parentId
    })
    if( matchingRootCategory !== undefined && payload.childCategories !== undefined){
      matchingRootCategory.ChildCategories = payload.childCategories;
    }    
  }
}

const actions = {
  LOAD_TENANT:  ({ commit, dispatch }) => {
    TenantService.GetTenantDetails().then(tenantResponse => {
      commit("SET_TENANT_DETAILS", tenantResponse.data)
    })
  },
  LOAD_CATALOG: async ({commit, getters}, {accountId, userId, audienceIds}) => {
    commit("SET_CATALOG_IS_LOADING",true)
    CatalogService.GetChildCategories(accountId, userId, state.costCenterRootCategoryId, getters.brandAuth, getters.regionAuth, audienceIds).then(catalogItems => {
      commit("SET_CATALOG_ROOT",catalogItems.data)
    }).then( () => {
      var catalogRootIds = state.catalogRoot.map(z => z.Id);
      CatalogService.GetChildCategories(accountId, userId, state.costCenterRootCategoryId, getters.brandAuth, getters.regionAuth, audienceIds, catalogRootIds ).then(rootChildren => {
        if(rootChildren !== undefined){
          //Group by parent id then save
          state.catalogRoot.forEach( async function(rootCategory){    
            var groupedChildren = rootChildren.data.filter(x => x.ParentCategoryId === rootCategory.Id)
            commit("SET_CATEGORY_ROOT_CHILDREN", { parentId: rootCategory.Id, childCategories: groupedChildren })
          }); 
        }
      })
      commit("SET_CATALOG_IS_LOADING",false)
    })
  },
  LOAD_CATEGORY: ({commit, dispatch }, {accountId, userId, categoryId, audienceIds}) => {
    commit("SET_CATEGORY_IS_LOADING", true)      
      CatalogService.GetCategory(accountId, userId, categoryId, audienceIds).then(category => {
        commit("SET_CATEGORY_HISTORY", category.data)
        commit("SET_CURRENT_CATEGORY_ID", category.data.Id)
      }).then( () => {
        commit("SET_CATEGORY_IS_LOADING", false)
      })
  },
  SET_CURRENT_CATEGORY_ID: ({commit, dispatch}, categoryId) => {
    commit("SET_CURRENT_CATEGORY_ID", categoryId)
  },
  SET_COST_CENTER_ROOT_CATEGORY_ID: async ({commit, dispatch}, result) => {
    var costCenterRootCategoryId = 0;
    var hostName = location.hostname;
    var rootCategoryKey = "MLA_ROOT_CATALOG_ID";

    if(hostName.includes("mle") || location.port == "8081"){
      rootCategoryKey = "MLE_ROOT_CATALOG_ID";

      //MLE Catalog Staging
      var mleTempRootCategoryId = _.find(result.result, (x) => x.Key == 'MLE_TEMP_ROOT_CATALOG_ID');
      var mleTempCategoryUserIds = _.find(result.result, (x) => x.Key == 'MLE_TEMP_CATALOG_USERS');

      if(mleTempRootCategoryId != null && mleTempCategoryUserIds != null && mleTempCategoryUserIds.Value.split(",").includes(result.userId.toString())){
        state.costCenterRootCategoryId = mleTempRootCategoryId.Value;
        return;
      }
    }

    costCenterRootCategoryId = _.find(result.result, (x) => x.Key == rootCategoryKey).Value;
    state.costCenterRootCategoryId = costCenterRootCategoryId;

  }

}

export default {
  getters,
  mutations,
  actions,
  state
}
